const jobs = [
  {
    companyName: "Genpact India Private Limited",
    companyLink: "https://www.genpact.com/",
    date: [new Date(2024, 5, 26), new Date(2024, 11, 13)], // June to December
    positionEN: "Process Associate",
    tasksEN: [
      "Conducted risk investigations to identify and mitigate potential threats.",
      "Assisted customers in North America and Germany, ensuring compliance with company policies and procedures.",
      "Resolved customer issues efficiently to maintain high levels of satisfaction.",
      "Documented and reported risk findings and resolutions to relevant stakeholders.",
      "Collaborated with team members to improve risk assessment and support processes.",
    ],
  },
  {
    companyName: "Infosys Ltd (Client: Apple)",
    companyLink: "https://www.infosys.com/",
    date: [new Date(2024, 11, 30), new Date()], // December ongoing
    positionEN: "Data Engineer",
    tasksEN: [
      "Designing, building, and maintaining scalable data pipelines for client Apple.",
      "Working extensively with Snowflake and SQL for data modeling, transformation, and optimization.",
      "Developing and maintaining ETL workflows to ensure smooth data flow across systems.",
      "Implementing data quality checks, monitoring jobs, and troubleshooting failures.",
      "Collaborating with cross-functional teams to define data requirements and deliver insights.",
      "Optimizing queries and storage for performance and cost efficiency.",
      "Supporting production pipelines and ensuring high availability of data services.",
      "Documenting workflows, processes, and best practices for knowledge sharing.",
    ],
  },
];

export default jobs;
